import React, {useEffect, useState} from "react";
// StripeCheckout removed - using Stripe Hosted Checkout instead
// import StripeCheckout from "react-stripe-checkout";
// import {loadStripe} from "@stripe/stripe-js";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../components/Loading";
import LaneService from "../services/LaneService";
import UserService from "../services/UserService";
import Progress from "./Progress";
import CompanyLogo from "../assets/farelanes-logo.png-modified.png";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/Subscriptions.css';


import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES } from "../config/routes";



//do something...


// import COPILOT from "../assets/images/pricing/FL-CP.png";
// import SILVERTOP from "../assets/images/pricing/farelanes-silver-sales-top.png";
// import GOLDTOP from "../assets/images/pricing/farelanes-gold-sales-top.png";
// import PLATINUMTOP from "../assets/images/pricing/farelanes-platinum-sales-top.png";

import COPILOT from "../assets/images/setup/product-copilot.svg";
import SILVERTOP from "../assets/images/setup/product-silver.svg";
import GOLDTOP from "../assets/images/setup/product-gold.svg";
import PLATINUMTOP from "../assets/images/setup/product-platinum.svg";

import COMINGSOON from "../assets/images/pricing/coming-soon-diag.png";
import SUBSCRIBE_MONTHLY from "../assets/images/pricing/yellow-subscribe-monthly.png";
import SUBSCRIBE_ANNUALLY from "../assets/images/pricing/yellow-subscribe-annually.png";
import FarelanesLogo from "../assets/images/get-b-2.png";
import {
    COPILOT_MONTHLY_API_KEY, COPILOT_YEARLY_API_KEY,
    GOLD_YEARLY_API_KEY,
    PLATINUM_MONTHLY_API_KEY,
    PLATINUM_YEARLY_API_KEY
} from "../common/ApiUrl";
import {GOLD_MONTHLY_API_KEY} from "../common/ApiUrl";
import {SILVER_YEARLY_API_KEY} from "../common/ApiUrl";
import {SILVER_MONTHLY_API_KEY} from "../common/ApiUrl";
import {STRIPE_KEY} from "../common/ApiUrl";
import {SignupButtonOne} from "./buttons/signup-button-one";
import {LoginButton} from "./buttons/login-button";
import {ProfileComponent} from "../pages/Profile";
import {initAmplitude, sendAmplitudeData, setAmplitudeUserId} from "../common/amplitude";
import {PageLoader} from "./PageLoader";

function TransactionProgress() {
    return null;
}

export const SubscriptionsComponent = ({ onDataChange, sharedData }) => {

    let navigate = useNavigate();
    const location = useLocation();

    let initialValues = {
        copilotCouponCode: '',
        silverCouponCode: '',
        goldCouponCode: '',
        platinumCouponCode: ''
    }

    const [quote, setQuote] = useState(initialValues)

    const onChange = (e) => {
        setQuote({...quote, [e.target.name]: e.target.value});
    };

    const [state, setState] = useState({
        allSubs: undefined,
        sub: undefined,
        noSub: false,
        isLoaded: false,
        data: undefined,
        content: "",
        showResult: false,
        apiMessage: undefined,
        error: null
    });

    const {
        getAccessTokenSilently,
        user
    } = useAuth0();

    const handleCheckoutError = (error) => {
        console.error("Error creating checkout session:", error);
        if (error?.response?.data?.error === "ALREADY_SUBSCRIBED") {
            toast.info("You already have an active subscription. Redirecting to Dashboard...");
            navigate(ROUTES.DASHBOARD, { replace: true });
        } else {
            toast.error("Failed to start checkout. Please try again.");
        }
    };

    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();

            UserService.getUserSubscription(token, user).then(
                response => {
                    console.log('Subscriptions API response:', response);
                    console.log('Response status:', response.status);
                    console.log('Response subscriptionType:', response.subscriptionType);
                    console.log('All subscriptions:', response.allSubSctiptions);
                    if (response.allSubSctiptions && response.allSubSctiptions.length > 0) {
                        console.log('First subscription in allSubSctiptions:', response.allSubSctiptions[0]);
                        console.log('First subscription type:', response.allSubSctiptions[0]?.subscriptionType);
                        console.log('First subscription status:', response.allSubSctiptions[0]?.status);
                    }

                    state.showResult = true;
                    state.data = response.allSubSctiptions;
                    state.sub = response;

                    // Sort subscriptions by created date (most recent first)
                    if (response.allSubSctiptions) {
                        response.allSubSctiptions.sort((a, b) => parseFloat(b.created || 0) - parseFloat(a.created || 0));
                    }

                    // Find the most recent active subscription (only one should show "Active" badge)
                    // This handles cases where multiple subscriptions are active during upgrade/downgrade transitions
                    let mostRecentActiveSub = null;
                    if (response.allSubSctiptions && response.allSubSctiptions.length > 0) {
                        mostRecentActiveSub = response.allSubSctiptions.find(sub =>
                            sub.status === true &&
                            sub.subscriptionType &&
                            sub.subscriptionType !== 'Default'
                        );
                    }

                    // Store the most recent active subscription type and plan type for badge display
                    if (mostRecentActiveSub) {
                        response._mostRecentActiveType = mostRecentActiveSub.subscriptionType;
                        response._mostRecentActivePlanType = mostRecentActiveSub.planType || 'Monthly';
                    }

                    // If subscriptionType is 'Default' but status is true, check allSubSctiptions for the actual type
                    if (response.status && response.subscriptionType === 'Default' && response.allSubSctiptions && response.allSubSctiptions.length > 0) {
                        // Find the most recent ACTIVE subscription with a valid type
                        // Only check subscriptions with status === true (strictly active)
                        const activeSub = response.allSubSctiptions.find(sub =>
                            sub.status === true &&
                            sub.subscriptionType &&
                            sub.subscriptionType !== 'Default' &&
                            (sub.subscriptionType === 'CoPilot' ||
                                sub.subscriptionType === 'Silver' ||
                                sub.subscriptionType === 'Gold' ||
                                sub.subscriptionType === 'Platinum')
                        );

                        if (activeSub) {
                            // Update response with active subscription data
                            response.subscriptionType = activeSub.subscriptionType;
                            response.subscriptionId = activeSub.subscriptionId;
                            response.stripeCustomerId = activeSub.stripeCustomerId;
                            console.log('Updated subscription type from allSubSctiptions:', activeSub);
                        } else {
                            // Check the first subscription in allSubSctiptions even if type is Default
                            const firstSub = response.allSubSctiptions[0];
                            if (firstSub && firstSub.subscriptionId) {
                                // Use the subscription from allSubSctiptions
                                response.subscriptionId = firstSub.subscriptionId;
                                response.stripeCustomerId = firstSub.stripeCustomerId;
                                console.log('Using subscription from allSubSctiptions:', firstSub);
                                // Try to infer type from subscription ID or other fields
                                // For now, we'll let the button logic handle it by checking allSubSctiptions
                            }
                        }
                    }

                    // If no active subscription in main response, check allSubSctiptions for active ones
                    if (!response.status && response.allSubSctiptions && response.allSubSctiptions.length > 0) {
                        // Find the most recent ACTIVE subscription with a valid type
                        // Only check subscriptions with status === true (strictly active)
                        const activeSub = response.allSubSctiptions.find(sub =>
                            sub.status === true &&
                            sub.subscriptionType &&
                            sub.subscriptionType !== 'Default' &&
                            (sub.subscriptionType === 'CoPilot' ||
                                sub.subscriptionType === 'Silver' ||
                                sub.subscriptionType === 'Gold' ||
                                sub.subscriptionType === 'Platinum')
                        );

                        if (activeSub) {
                            // Update response with active subscription data
                            response.status = true;
                            response.subscriptionType = activeSub.subscriptionType;
                            response.subscriptionId = activeSub.subscriptionId;
                            response.stripeCustomerId = activeSub.stripeCustomerId;
                            console.log('Found active subscription in allSubSctiptions:', activeSub);
                        }
                    }

                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data,
                        sub: response,
                        data: response.allSubSctiptions
                    });

                    if (!response.status) {
                        state.sub = 'M';
                        state.noSub = true;
                        setState({
                            ...state,
                            sub: 'M',
                            noSub: true,
                        });
                    }
                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    };


    useEffect(() => {
        callApi();
    }, []);

    // Refetch subscription data when returning from Stripe
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const fromStripe = searchParams.get('from') === 'stripe';

        if (fromStripe) {
            console.log('Detected return from Stripe - refreshing subscription data...');
            // Immediately refetch with forceRefresh=true to bypass cache (backend will invalidate cache on webhook)
            // This ensures we get the latest data from Stripe, even if webhook hasn't fired yet
            const fetchWithForceRefresh = async () => {
                try {
                    const token = await getAccessTokenSilently();
                    // Add forceRefresh=true to bypass Redis cache
                    const response = await UserService.getUserSubscription(token, user, true);
                    console.log('Force refresh response:', response);
                    if (response && response.allSubSctiptions) {
                        response.allSubSctiptions.sort((a, b) => parseFloat(b.created || 0) - parseFloat(a.created || 0));
                    }
                    // Update state with fresh data
                    setState(prevState => ({
                        ...prevState,
                        showResult: true,
                        sub: response,
                        data: response.allSubSctiptions
                    }));
                } catch (error) {
                    console.error('Error force refreshing subscription data:', error);
                    // Fallback to regular callApi
                    callApi();
                }
            };

            fetchWithForceRefresh();

            // Retry after delays to ensure webhook has processed any changes
            // Webhooks can take a few seconds to fire after changes in Stripe Customer Portal
            const retries = [3000, 6000]; // 3 seconds and 6 seconds
            const retryTimeouts = retries.map(delay =>
                setTimeout(() => {
                    console.log(`Retrying subscription data fetch after ${delay}ms (webhook processing time)...`);
                    fetchWithForceRefresh();
                }, delay)
            );

            // Clean up URL parameter after refresh
            searchParams.delete('from');
            const newSearch = searchParams.toString();
            const newUrl = newSearch
                ? `${location.pathname}?${newSearch}`
                : location.pathname;
            navigate(newUrl, { replace: true });

            // Cleanup timeouts on unmount
            return () => {
                retryTimeouts.forEach(timeout => clearTimeout(timeout));
            };
        }
    }, [location.search, navigate, getAccessTokenSilently, user]);

    async function handleCoPilotCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                COPILOT_MONTHLY_API_KEY,
                'CoPilot',
                'Monthly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'COPILOT MONTHLY',
                    'email': user.email
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }
    async function handleSilverCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                SILVER_MONTHLY_API_KEY,
                'Silver',
                'Monthly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'SILVER MONTHLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }

    async function handleCoPilotAnnualCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                COPILOT_YEARLY_API_KEY,
                'CoPilot',
                'Yearly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'COPILOT YEARLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }

    async function handleSilverAnnualCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                SILVER_YEARLY_API_KEY,
                'Silver',
                'Yearly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'SILVER YEARLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }

    async function handleGoldCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                GOLD_MONTHLY_API_KEY,
                'Gold',
                'Monthly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'GOLD MONTHLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }

    async function handleGoldYearlyCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                GOLD_YEARLY_API_KEY,
                'Gold',
                'Yearly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'GOLD YEARLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }


    async function handlePlatinumCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                PLATINUM_MONTHLY_API_KEY,
                'Platinum',
                'Monthly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'PLATINUM MONTHLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }

    async function handlePlatinumYearlyCheckout() {
        toast("Redirecting you to our secure payment gateway to complete your subscription...");
        try {
            const serverToken = await getAccessTokenSilently();
            const response = await UserService.createCheckoutSession(
                PLATINUM_YEARLY_API_KEY,
                'Platinum',
                'Yearly Recurring',
                user.email,
                '', // Coupon codes can be entered directly on Stripe checkout page
                serverToken
            );

            if (response.data && response.data.url) {
                //Add analytics
                initAmplitude();
                setAmplitudeUserId(user.email);
                sendAmplitudeData("Checkout Session Created", {
                    'subscription_type': 'PLATINUM YEARLY',
                    'email': user.email,
                });
                //End Analytics
                // Redirect to Stripe hosted checkout
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to create checkout session");
            }
        } catch (error) {
            handleCheckoutError(error);
        }
    }

    async function handleManageSubscription(e) {
        e.preventDefault();
        toast("Redirecting you to our secure payment gateway to manage your subscription...");

        try {
            const serverToken = await getAccessTokenSilently();
            // Return to Dashboard with Setup->Subscriptions tab selected and from=stripe flag for toast
            const returnUrl = window.location.origin + '/dashboard?tab=setup&subtab=subscriptions&from=stripe';

            const response = await UserService.createPortalSession(returnUrl, serverToken);

            if (response && response.data && response.data.url) {
                // Redirect to Stripe Customer Portal
                window.location.href = response.data.url;
            } else {
                toast.error("Failed to open subscription management portal");
            }
        } catch (error) {
            console.error("Error opening portal session:", error);
            toast.error("Failed to open subscription management. Please try again.");
        }
    }

    return (
        <>
            <div className="form-group ">
                <div>

                    {/*<ToastContainer />*/}

                    <ToastContainer
                        className= "toast-message"
                        position="top-center"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                    {/* Same as */}
                    {!state.showResult &&
                        <div>
                            <PageLoader></PageLoader>
                        </div>
                    }


                    {state.showResult && (
                        <div>
                            <section id="pricing" className="pricing-content" style={{paddingTop: '5px', paddingBottom: '20px'}}>
                                <div className="container-fluid" style={{paddingTop: '0'}}>

                                    {/* Subscription Management Section - All managed through Stripe Customer Portal */}
                                    {(() => {
                                        const hasActiveSubscription = state.sub && state.sub.status === true && state.sub.subscriptionId;
                                        const subscriptionId = state.sub?.subscriptionId ||
                                            (state.data && state.data.length > 0 && state.data[0]?.subscriptionId);

                                        const hasAnySubscription = hasActiveSubscription ||
                                            (state.data && state.data.some(sub =>
                                                sub.subscriptionId &&
                                                sub.status === true &&
                                                sub.subscriptionType !== 'Default'
                                            ));

                                        return hasAnySubscription && subscriptionId && (
                                            <div style={{textAlign: 'center', marginBottom: '15px', marginTop: '5px'}}>
                                                <button
                                                    type="button"
                                                    className="button__logout more_style_price_buttons manage-subscription-button"
                                                    onClick={handleManageSubscription}
                                                    style={{
                                                        outline: 'none',
                                                        border: 'none',
                                                        whiteSpace: 'nowrap',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '6px',
                                                        fontSize: '13px',
                                                        letterSpacing: '0.8px',
                                                        padding: '12px 24px',
                                                        lineHeight: '1.6rem',
                                                        width: 'auto',
                                                        cursor: 'pointer',
                                                        position: 'relative'
                                                    }}
                                                >
                                                    MANAGE SUBSCRIPTION & INVOICING
                                                    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink: 0, transition: 'transform 0.3s ease'}}>
                                                        <path d="M6 12l4-4-4-4"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        );
                                    })()}

                                    <div className="row text-center" style={{marginTop: '0'}}>

                                        {/*Farelanes copilot*/}
                                        <div className="col-3 pricing-item pricing-item-copilot" data-wow-duration="1s" data-wow-delay="0.1s" data-wow-offset="0">
                                            <div className="pricing_design">
                                                <div className="single-pricing" style={{position: 'relative'}}>

                                                    <div className="fcuk">
                                                        <div className="price-head">
                                                            <img className="copilottop" src={COPILOT} alt="Farelanes CoPilot"/>
                                                            <small>Farelanes CoPilot</small>
                                                            <h1>$10</h1>
                                                            <p>per month<br/>or get two months FREE<br/>when you pay $100/year!</p>
                                                        </div>

                                                        {/* Subscription Status Badge - Below Image */}
                                                        {(() => {
                                                            // Only show Active badge if this is the most recent active subscription
                                                            const mostRecentActiveType = state.sub?._mostRecentActiveType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.subscriptionType);
                                                            const mostRecentActivePlanType = state.sub?._mostRecentActivePlanType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.planType) || 'Monthly';
                                                            const hasCoPilot = mostRecentActiveType === 'CoPilot';

                                                            return hasCoPilot && (
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    gap: '12px',
                                                                    marginTop: '15px',
                                                                    marginBottom: '15px'
                                                                }}>
                                                                    {/* Single unified badge with both status and plan type */}
                                                                    <div style={{
                                                                        backgroundColor: '#39B54A',
                                                                        color: 'white',
                                                                        padding: '10px 18px',
                                                                        borderRadius: '25px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '12px',
                                                                        boxShadow: '0 3px 12px rgba(57, 181, 74, 0.35)',
                                                                        whiteSpace: 'nowrap',
                                                                        position: 'relative',
                                                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        }}>
                                                                            <div style={{
                                                                                width: '8px',
                                                                                height: '8px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: 'white',
                                                                                boxShadow: '0 0 6px rgba(255, 255, 255, 0.6)',
                                                                                animation: 'pulse 2s infinite'
                                                                            }}></div>
                                                                            <span>Active</span>
                                                                        </div>
                                                                        <div style={{
                                                                            width: '1px',
                                                                            height: '16px',
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.3)'
                                                                        }}></div>
                                                                        <span>{mostRecentActivePlanType === 'Annual' ? 'Yearly' : 'Monthly'}</span>
                                                                    </div>
                                                                    {/* Upgrade message for monthly subscriptions */}
                                                                    {mostRecentActivePlanType === 'Monthly' && (
                                                                        <div style={{
                                                                            textAlign: 'center',
                                                                            fontSize: '12px',
                                                                            color: '#666',
                                                                            marginTop: '8px',
                                                                            padding: '8px 12px',
                                                                            backgroundColor: '#fff9e6',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #ffc107'
                                                                        }}>
                                                                            Upgrade to yearly and get 2 months free.{' '}
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleManageSubscription(e);
                                                                                }}
                                                                                style={{
                                                                                    color: '#ffc107',
                                                                                    textDecoration: 'underline',
                                                                                    fontWeight: '600',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                Update subscription
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Subscribe Buttons - Top aligned */}
                                                        {!state.sub || state.sub == 'M' ? (
                                                            <div className="btn-group a01" style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '15px', marginBottom: '20px', flexWrap: 'wrap'}}>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handleCoPilotCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> MONTHLY
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handleCoPilotAnnualCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> ANNUALLY
                                                                </button>
                                                            </div>
                                                        ) : null}

                                                        <div className="price-body">
                                                            <h6>Mobile-only Version</h6>
                                                            <ul>
                                                                <li><strong>Exclusive Mobile Access: </strong>Enjoy all features on the go! </li>
                                                                <li><strong>200 monthly searches: </strong>City/Pairs line haul rates</li>
                                                                <li><strong>Comprehensive Rate History: </strong>Access rates from the past 3 days up to 4 months ago! </li>
                                                                <li><strong>Diverse Equipment Selection: </strong>Over 25 types, including all trailer types & power only! </li>
                                                            </ul>

                                                            {/*<li>Mobile Only Version</li>*/}
                                                            {/*<li>Search</li>
																<li>Limited Daily and Monthly Search Limit</li>
																<li>All Trailer Types & Power Only</li>
																<li>All Daily - 10 Lane Searches</li>
																<li>All Monthly - 300 Lane Searches</li>*/}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/*farelanes copilot end*/}

                                        {/*Farelanes silver start*/}
                                        <div className="col-3 pricing-item pricing-item-silver" data-wow-duration="1s" data-wow-delay="0.1s" data-wow-offset="0">
                                            <div className="pricing_design">
                                                <div className="single-pricing" style={{position: 'relative'}}>

                                                    <div className="fcuk">
                                                        <div className="price-head">
                                                            <img className="silver-top" src={SILVERTOP} alt="Farelanes Silver"/>
                                                            <small>Farelanes Silver</small>
                                                            <h1>$50</h1>
                                                            <p>per month<br/>or get two months FREE<br/>when you pay $500/year!</p>
                                                        </div>

                                                        {/* Subscription Status Badge - Below Image */}
                                                        {(() => {
                                                            // Only show Active badge if this is the most recent active subscription
                                                            const mostRecentActiveType = state.sub?._mostRecentActiveType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.subscriptionType);
                                                            const mostRecentActivePlanType = state.sub?._mostRecentActivePlanType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.planType) || 'Monthly';
                                                            const hasSilver = mostRecentActiveType === 'Silver';

                                                            return hasSilver && (
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    gap: '12px',
                                                                    marginTop: '15px',
                                                                    marginBottom: '15px'
                                                                }}>
                                                                    {/* Single unified badge with both status and plan type */}
                                                                    <div style={{
                                                                        backgroundColor: '#39B54A',
                                                                        color: 'white',
                                                                        padding: '10px 18px',
                                                                        borderRadius: '25px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '12px',
                                                                        boxShadow: '0 3px 12px rgba(57, 181, 74, 0.35)',
                                                                        whiteSpace: 'nowrap',
                                                                        position: 'relative',
                                                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        }}>
                                                                            <div style={{
                                                                                width: '8px',
                                                                                height: '8px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: 'white',
                                                                                boxShadow: '0 0 6px rgba(255, 255, 255, 0.6)',
                                                                                animation: 'pulse 2s infinite'
                                                                            }}></div>
                                                                            <span>Active</span>
                                                                        </div>
                                                                        <div style={{
                                                                            width: '1px',
                                                                            height: '16px',
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.3)'
                                                                        }}></div>
                                                                        <span>{mostRecentActivePlanType === 'Annual' ? 'Yearly' : 'Monthly'}</span>
                                                                    </div>
                                                                    {/* Upgrade message for monthly subscriptions */}
                                                                    {mostRecentActivePlanType === 'Monthly' && (
                                                                        <div style={{
                                                                            textAlign: 'center',
                                                                            fontSize: '12px',
                                                                            color: '#666',
                                                                            marginTop: '8px',
                                                                            padding: '8px 12px',
                                                                            backgroundColor: '#fff9e6',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #ffc107'
                                                                        }}>
                                                                            Upgrade to yearly and get 2 months free.{' '}
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleManageSubscription(e);
                                                                                }}
                                                                                style={{
                                                                                    color: '#ffc107',
                                                                                    textDecoration: 'underline',
                                                                                    fontWeight: '600',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                Update subscription
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Subscribe Buttons - Top aligned */}
                                                        {!state.sub || state.sub == 'M' ? (
                                                            <div className="btn-group a01" style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '15px', marginBottom: '20px', flexWrap: 'wrap'}}>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handleSilverCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> MONTHLY
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handleSilverAnnualCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> ANNUALLY
                                                                </button>
                                                            </div>
                                                        ) : null}

                                                        <div className="price-body">
                                                            <ul>
                                                                <li><strong>Web App Optimization: </strong>Seamless experience on desktop and tablet devices.</li>
                                                                <li><strong>Favorite Lane Tracking: </strong>Save up to 3 top-performing routes for quick access.</li>
                                                                <li><strong>Top Paying Lanes: </strong>View high-yield lanes with real-time rate updates.</li>
                                                                <li><strong>Rate Tickers & Scopes: </strong>Monitor lane trends with smart visual tools.</li>
                                                                <li><strong>Confidence Indicator: </strong>Based on actual paid invoices for market accuracy.</li>
                                                                <li><strong>Rate Trend History: </strong>Analyze averages from 3 days to 4 months for smarter decisions.</li>
                                                                <li><strong>500 monthly searches: </strong>City/Pairs line haul rates</li>
                                                            </ul>

                                                            {/*<li>Search</li>
																<li>City Pair Line Haul Rates</li>
																<li>All Trailer Types & Power Only</li>
																<li>Personalize</li>
																<li>Favorite Lanes</li>
																<li>City Pair Rate Tickers</li>
																<li>Top Paying <em>Lanes with rates always available</em></li>
																<li>Programmable Desktop with memory</li>
																<li>Scopes from setup - favorite city pairs</li>
																<li>Unlimited desktop city pairs</li>
																<li>AI for managing Text, <em>Reporting, and other new GOLD and PLATINUM TASKS</em></li>*/}
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        {/*farelanes copliot end*/}

                                        <div className="col-3 pricing-item pricing-item-gold"
                                             data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                                            <div className="pricing_design">
                                                <div className="single-pricing" style={{position: 'relative'}}>
                                                    <div className="fcuk">
                                                        <div className="price-head">
                                                            <img className="silver-top" src={GOLDTOP} alt="Farelanes Gold"/>
                                                            <small>Farelanes Gold</small>
                                                            <h1>$100</h1>
                                                            <p>per month<br/>or get two months FREE<br/>when you pay $1000/year!</p>
                                                        </div>

                                                        {/* Subscription Status Badge - Below Image */}
                                                        {(() => {
                                                            // Only show Active badge if this is the most recent active subscription
                                                            const mostRecentActiveType = state.sub?._mostRecentActiveType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.subscriptionType);
                                                            const mostRecentActivePlanType = state.sub?._mostRecentActivePlanType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.planType) || 'Monthly';
                                                            const hasGold = mostRecentActiveType === 'Gold';

                                                            return hasGold && (
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    gap: '12px',
                                                                    marginTop: '15px',
                                                                    marginBottom: '15px'
                                                                }}>
                                                                    {/* Single unified badge with both status and plan type */}
                                                                    <div style={{
                                                                        backgroundColor: '#39B54A',
                                                                        color: 'white',
                                                                        padding: '10px 18px',
                                                                        borderRadius: '25px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '12px',
                                                                        boxShadow: '0 3px 12px rgba(57, 181, 74, 0.35)',
                                                                        whiteSpace: 'nowrap',
                                                                        position: 'relative',
                                                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        }}>
                                                                            <div style={{
                                                                                width: '8px',
                                                                                height: '8px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: 'white',
                                                                                boxShadow: '0 0 6px rgba(255, 255, 255, 0.6)',
                                                                                animation: 'pulse 2s infinite'
                                                                            }}></div>
                                                                            <span>Active</span>
                                                                        </div>
                                                                        <div style={{
                                                                            width: '1px',
                                                                            height: '16px',
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.3)'
                                                                        }}></div>
                                                                        <span>{mostRecentActivePlanType === 'Annual' ? 'Yearly' : 'Monthly'}</span>
                                                                    </div>
                                                                    {/* Upgrade message for monthly subscriptions */}
                                                                    {mostRecentActivePlanType === 'Monthly' && (
                                                                        <div style={{
                                                                            textAlign: 'center',
                                                                            fontSize: '12px',
                                                                            color: '#666',
                                                                            marginTop: '8px',
                                                                            padding: '8px 12px',
                                                                            backgroundColor: '#fff9e6',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #ffc107'
                                                                        }}>
                                                                            Upgrade to yearly and get 2 months free.{' '}
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleManageSubscription(e);
                                                                                }}
                                                                                style={{
                                                                                    color: '#ffc107',
                                                                                    textDecoration: 'underline',
                                                                                    fontWeight: '600',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                Update subscription
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Subscribe Buttons - Top aligned */}
                                                        {!state.sub || state.sub == 'M' ? (
                                                            <div className="btn-group a02" style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '15px', marginBottom: '20px', flexWrap: 'wrap'}}>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handleGoldCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> MONTHLY
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handleGoldYearlyCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> ANNUALLY
                                                                </button>
                                                            </div>
                                                        ) : null}

                                                        <div className="price-body">
                                                            <h6>Everything Silver has to offer&nbsp;plus:</h6>
                                                            <ul>
                                                                <li><strong>Custom Dashboards: </strong>Build layouts and save views to fit your workflow.</li>
                                                                <li><strong>Unlimited Favorite Lanes: </strong>Track endless city pairs—no restrictions.</li>
                                                                <li><strong>Advanced Lane Scopes: </strong>Create deep scopes from favorite lanes for richer insights.</li>
                                                                <li><strong>RFQ Tools: </strong>Upload bulk lanes and get instant downloadable pricing.</li>
                                                                <li><strong>Trend Analysis: </strong>Compare lanes across timeframes and market segments.</li>
                                                                <li><strong>AI Reporting: </strong>Automate text and reporting with built-in AI.</li>
                                                                <li><strong>2000 monthly searches: </strong>City/Pairs line haul rates</li>
                                                            </ul>
                                                            {/*<li>*Request for Quote (RFQ) via Spreadsheet</li>
																<li>*Reporting</li>
																<li>Load/Price analytics by equipment, Date(s)</li>
																<li>Last 6 months lane analytics, export</li>
																<li>Hinting in your Favorite Lanes(now optionable)</li>
																<li>Tool Tip hinting reveals assessorial details</li>
																<li>City Pair Loading with level 2 detail</li>
																<li> Level 2 load optics enable (pick / drop zone, load analysis, lane rates vs. linehaul, Fuel surcharge, all assessorial fees optics by load)</li>
																<li>Export level 2 data for additional analysis and reporting</li>
																<li>*Realtime - Petroleum by lane – city pair Weather by lane – city pair *AI for managing Text, Reporting, and other new GOLD and PLATINUM TASKS</li>*/}
                                                        </div>


                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-3 pricing-item pricing-item-platinum"
                                             data-wow-duration="1s"
                                             data-wow-delay="0.1s" data-wow-offset="0">
                                            <div className="pricing_design">
                                                <div className="single-pricing" style={{position: 'relative'}}>
                                                    <div className="fcuk">
                                                        <div className="price-head">
                                                            <img className="silver-top" src={PLATINUMTOP} alt="Farelanes Platinum"/>
                                                            <small>Farelanes Platinum</small>
                                                            <h1>$200</h1>
                                                            <p>per month<br/>or get two months FREE<br/>when you pay $2000/year!</p>
                                                        </div>

                                                        {/* Subscription Status Badge - Below Image */}
                                                        {(() => {
                                                            // Only show Active badge if this is the most recent active subscription
                                                            const mostRecentActiveType = state.sub?._mostRecentActiveType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.subscriptionType);
                                                            const mostRecentActivePlanType = state.sub?._mostRecentActivePlanType ||
                                                                (state.data && state.data.length > 0 && state.data.find(sub => sub.status === true)?.planType) || 'Monthly';
                                                            const hasPlatinum = mostRecentActiveType === 'Platinum';

                                                            return hasPlatinum && (
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    gap: '12px',
                                                                    marginTop: '15px',
                                                                    marginBottom: '15px'
                                                                }}>
                                                                    {/* Single unified badge with both status and plan type */}
                                                                    <div style={{
                                                                        backgroundColor: '#39B54A',
                                                                        color: 'white',
                                                                        padding: '10px 18px',
                                                                        borderRadius: '25px',
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '12px',
                                                                        boxShadow: '0 3px 12px rgba(57, 181, 74, 0.35)',
                                                                        whiteSpace: 'nowrap',
                                                                        position: 'relative',
                                                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        }}>
                                                                            <div style={{
                                                                                width: '8px',
                                                                                height: '8px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: 'white',
                                                                                boxShadow: '0 0 6px rgba(255, 255, 255, 0.6)',
                                                                                animation: 'pulse 2s infinite'
                                                                            }}></div>
                                                                            <span>Active</span>
                                                                        </div>
                                                                        <div style={{
                                                                            width: '1px',
                                                                            height: '16px',
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.3)'
                                                                        }}></div>
                                                                        <span>{mostRecentActivePlanType === 'Annual' ? 'Yearly' : 'Monthly'}</span>
                                                                    </div>
                                                                    {/* Upgrade message for monthly subscriptions */}
                                                                    {mostRecentActivePlanType === 'Monthly' && (
                                                                        <div style={{
                                                                            textAlign: 'center',
                                                                            fontSize: '12px',
                                                                            color: '#666',
                                                                            marginTop: '8px',
                                                                            padding: '8px 12px',
                                                                            backgroundColor: '#fff9e6',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #ffc107'
                                                                        }}>
                                                                            Upgrade to yearly and get 2 months free.{' '}
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleManageSubscription(e);
                                                                                }}
                                                                                style={{
                                                                                    color: '#ffc107',
                                                                                    textDecoration: 'underline',
                                                                                    fontWeight: '600',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                Update subscription
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Subscribe Buttons - Top aligned */}
                                                        {!state.sub || state.sub == 'M' ? (
                                                            <div className="btn-group a01" style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '15px', marginBottom: '20px', flexWrap: 'wrap'}}>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handlePlatinumCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> MONTHLY
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="button__logout more_style_price_buttons"
                                                                    onClick={handlePlatinumYearlyCheckout}
                                                                    style={{flex: '1', minWidth: '140px', outline: 'none', border: 'none'}}
                                                                >
                                                                    <small>SUBSCRIBE</small> ANNUALLY
                                                                </button>
                                                            </div>
                                                        ) : null}

                                                        <div className="price-body">
                                                            <h6>Everything Gold has to offer&nbsp;plus:</h6>
                                                            <ul>
                                                                <li><strong>Exclusive acces to Milemaker, powered by Rand McNally: </strong>Use Rand McNally-powered routing for precision pricing.</li>
                                                                <li><strong>Spreadsheet RFQ: </strong>Upload bulk lanes for enhanced quote automation.</li>
                                                                <li><strong>Lane Hinting: </strong>Toggle hints in favorite lanes for added context.</li>
                                                                <li><strong>Tooltip Details: </strong>Reveal assessorial fees with hover-based insights.</li>
                                                                <li><strong>City Pair Loading: </strong>Access deeper lane-level data for each pair.</li>
                                                                <li><strong>Level 2 Optics: </strong>Analyze pick/drop zones, linehaul vs. lane rates, fuel, and fees.</li>
                                                                <li><strong>Data Export: </strong>Download Level 2 insights for custom reporting.</li>
                                                                <li><strong>Real-Time Lane Intel: </strong>View petroleum and weather data by city pair.</li>
                                                                <li><strong>AI Image Tools: </strong>Convert visuals to text, reports, and insights.</li>
                                                                <li><strong>Insights Tab: </strong>Explore top equipment types and market indexes.</li>
                                                                <li><strong>Load Analytics: </strong>Break down pricing by equipment and date.</li>
                                                                <li><strong>Lane History: </strong>Access one year of lane data for export and analysis.</li>
                                                                <li><strong>4000 monthly searches: </strong>City/Pairs line haul rates</li>
                                                                {/*<li><strong>Exclusive access to Milemaker, powered by Rand McNally</strong></li>
																<li>*Enhanced Request for Quote (RFQ) via Spreadsheet</li>
																<li>Hinting in your Favorite Lanes (now optionable)</li>
																<li>Tool Tip hinting reveals assessorial details</li>
																<li>City Pair Loading with level 2 detail</li>
																<li> Level 2 load optics enable (pick / drop zone, load analysis, lane rates vs. linehaul, Fuel surcharge, all assessorial fees optics by load)</li>
																<li>Export level 2 data for additional analysis and reporting</li>
																<li>*Realtime - Petroleum by lane – city pair Weather by lane – city pair</li>
																<li>*AI for converting images to Text, Reporting, and Insights</li>
																<li>*New Insights Reporting Tab with top 6 equipment types and Market Indexes</li>
																<li> Load/Price analytics by equipment, Date(s)</li>
																<li> 1 Year lane history analytics, reporting / export</li>*/}
                                                            </ul>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>


                                </div>
                            </section>
                        </div>)}

                </div>
            </div>
        </>
    );
};

export default withAuthenticationRequired(SubscriptionsComponent, {
    onRedirecting: () => <Loading/>,
});
